<template>
    <o-form-wrapper
        :form-state="formState"
        :schema="schema"
        :server-errors="_se"
        :v="$v.item"
        v-model="item"
    >
        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="username"
        >
            <o-text-field
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                name="username"
                v-bind="schema.fields.username"
                v-model="item.username"
            ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="new_password"
        >
            <o-text-field
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                name="new_password"
                v-bind="schema.fields.new_password"
                v-model="item.new_password"
            ></o-text-field>
        </o-widget-wrapper>

        <h4>Personal Info</h4>

        <div class="row no-gutters justify-content-end">
            <div class="col-lg-11 col-12 d-lg-flex">
                <div class="col-lg-6 col-12">
                    <o-widget-wrapper
                        :form-state="formState"
                        :schema="schema"
                        :server-errors="_se"
                        :validators="$v.item"
                        name="first_name"
                    >
                        <o-text-field
                            label="Name *"
                            :form-state="formState"
                            placeholder="First Name"
                            :server-errors="_se"
                            :validators="$v.item"
                            name="first_name"
                            v-bind="schema.fields.first_name"
                            v-model="item.first_name"
                        ></o-text-field>
                    </o-widget-wrapper>
                </div>
                <div class="col-lg-6 col-12">
                    <o-widget-wrapper
                        :form-state="formState"
                        :schema="schema"
                        :server-errors="_se"
                        :validators="$v.item"
                        name="last_name"
                    >
                        <o-text-field
                            nolabel
                            :form-state="formState"
                            placeholder="Last Name"
                            :server-errors="_se"
                            :validators="$v.item"
                            name="last_name"
                            v-bind="schema.fields.last_name"
                            v-model="item.last_name"
                        ></o-text-field>
                    </o-widget-wrapper>
                </div>
            </div>
        </div>

        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="email"
        >
            <o-text-field
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                name="email"
                v-bind="schema.fields.email"
                v-model="item.email"
            ></o-text-field>
        </o-widget-wrapper>

        <h4>Permissions</h4>

        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="is_active"
        >
            <o-checkbox
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                name="is_active"
                v-bind="schema.fields.is_active"
                v-model="item.is_active"
            ></o-checkbox>
        </o-widget-wrapper>

        <o-widget-wrapper
            v-if="advancedUsage"
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="is_staff"
        >
            <o-checkbox
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                name="is_staff"
                v-bind="schema.fields.is_staff"
                v-model="item.is_staff"
            ></o-checkbox>
        </o-widget-wrapper>

        <!--<o-widget-wrapper :schema="schema" name="is_superuser" :validators="$v.item" :server-errors="_se"
                          :form-state="formState">
            <o-checkbox
                v-model="item.is_superuser"

                :form-state="formState"
                name="is_superuser" :validators="$v.item" :server-errors="_se" v-bind="schema.fields.is_superuser"
            ></o-checkbox>
        </o-widget-wrapper>-->

        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="groups"
        >
            <o-multi-checkbox
                :form-state="formState"
                :items="optionGroupItems"
                :loading="optionGroupWorking"
                :server-errors="_se"
                :validators="$v.item"
                name="group"
                sort-field="name"
                text-field="name"
                v-bind="schema.fields.groups"
                v-model="item.groups"
                value-field="id"
            >
            </o-multi-checkbox>
        </o-widget-wrapper>

        <o-widget-wrapper
            v-if="advancedUsage"
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="user_permissions"
        >
            <div style="overflow-y: scroll; overflow-x: hidden; height: 200px">
                <o-multi-checkbox
                    :form-state="formState"
                    :items="optionPermissionItems"
                    :loading="optionPermissionWorking"
                    :server-errors="_se"
                    :validators="$v.item"
                    multiple
                    name="user_permissions"
                    sort-field="name"
                    text-field="name"
                    v-bind="schema.fields.user_permissions"
                    v-model="item.user_permissions"
                    value-field="id"
                >
                </o-multi-checkbox>
            </div>
        </o-widget-wrapper>

        <h4>Important Dates</h4>

        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="last_login"
        >
            <o-date-time
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                disabled
                name="last_login"
                v-bind="schema.fields.last_login"
                v-model="item.last_login"
            ></o-date-time>
        </o-widget-wrapper>

        <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="date_joined"
        >
            <o-date-time
                :form-state="formState"
                :server-errors="_se"
                :validators="$v.item"
                disabled
                name="date_joined"
                v-bind="schema.fields.date_joined"
                v-model="item.date_joined"
            ></o-date-time>
        </o-widget-wrapper>
    </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../schema/schema_vuetify";
import {
    CreateCodeTableFetchMixin,
    CreateFormStateMixin,
    CreateGroupPermissionMixin,
    VuelidateMixin,
} from "../../../mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../components/forms/OWidgetWrapper";
import OTextField from "../../../components/forms/fields/OTextField";
import OSelect from "../../../components/forms/fields/OSelect";
import OCheckbox from "../../../components/forms/fields/OCheckbox";
import OFormWrapper from "../../../components/forms/OFormWrapper";
import ODateTime from "../../../components/forms/fields/ODateTime";
import { default as GroupForm } from "../../group/components/ItemForm";
// import { default as GroupFormCards } from '../../group/components/ItemFormCards';
import { default as PermissionForm } from "../../permission/components/ItemForm";
import OMultiCheckbox from "../../../components/forms/fields/OMultiCheckbox";
// import { default as PermissionFormCards } from '../../permission/components/ItemFormCards';

export default {
    mixins: [
        VuelidateMixin,
        validationMixin,
        CreateFormStateMixin("$v"),
        CreateGroupPermissionMixin("User"),
        CreateCodeTableFetchMixin(["Group", "Permission"]),
    ],
    components: {
        OMultiCheckbox,
        OFormWrapper,
        OWidgetWrapper,
        ODateTime,

        OCheckbox,
        OSelect,
        OTextField,

        GroupForm,
        //GroupFormCards,
        PermissionForm,
        //PermissionFormCards,
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        level: { type: Number, default: 0 },
        inModal: { type: Boolean, default: false },
        advancedUsage: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        schemaModel: cleanUpModel(schema.User, {}),
    }),
    methods: {},
    computed: {
        _se() {
            // Return an empty Object if there are no Server Errors to avoid Binding Errors
            return this.serverErrors || {};
        },
    },
    watch: {},
    created() {},
};
</script>
